<template>
	<div>
		<ul class="list-unstyled multi-steps">
			<li :class="step == 1 ? 'is-active':''">{{ $t('label.register') }}</li>
			<li :class="step == 2 ? 'is-active':''">{{ $t('label.profile') }}</li>
			<li :class="step == 3 ? 'is-active':''">{{ $t('label.vehicle_and_driver') }}</li>
			<li :class="step == 4 ? 'is-active':''">{{ $t('label.application') }}</li>
		</ul>
	</div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default { 
	computed: {
		fas() { return fas; }
	},
	data() {
		return {
			baseURI: "",
			step: 1
		}
	},
	mounted() {
		this.getStep();
		var childs = $("#multistep").children().length;
		var width = (100 / childs) + "%";
		$(".multistep-step").css("width", width);
	},
	methods: {
		getStep(){
			this.$store.state.loading.status = true;
			let url = this.baseURI + 'profile/step';
			GDCE_Client.requestApi("GET", url).then(response => {
				this.step = response.data;
				this.$store.state.loading.status = false;
			}).catch((error) => {
        console.warn(error);
        this.$store.state.loading.status = false;
      });
		}
	}
}
</script>

<style scoped>
	.multi-steps > li.is-active:before, 
	.multi-steps > li.is-active ~ li:before {
		content: counter(stepNum);
		font-family: inherit;
		font-weight: 700;
		color: #000000;
	}
	.multi-steps > li.is-active {
		color: #000000;
	}
	.multi-steps > li.is-active:after, 
	.multi-steps > li.is-active ~ li:after {
		background-color: #707070;
	}

	.multi-steps {
		display: table;
		table-layout: fixed;
		width: 100%;
	}
	.multi-steps > li {
		counter-increment: stepNum;
		text-align: center;
		display: table-cell;
		position: relative;
		color: #008800;
	}
	.multi-steps > li:before {
		content: "\2713";
		display: block;
		position: relative;
		margin: 0 auto 10px;
		background-color: #ffffff;
		width: 50px;
		height: 50px;
		line-height: 46px;
		text-align: center;
		font-weight: bold;
		border-width: 3px;
		border-style: solid;
		border-color: #008800;
		border-radius: 50%;
		z-index: 1;
	}
	.multi-steps > li:after {
		content: "";
		height: 3px;
		width: 100%;
		background-color: #008800;
		position: absolute;
		top: 25px;
		left: 50%;
		z-index: 0;
	}
	.multi-steps > li:last-child:after {
		display: none;
	}
	.multi-steps > li.is-active:before {
		background-color: #ffffff;
		border-color: #707070;
	}
	.multi-steps > li.is-active ~ li {
		color: #000000;
	}
	.multi-steps > li.is-active ~ li:before {
		background-color: #ffffff;
		border-color: #707070;
	}
</style>